<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增岗位</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="岗位名称" prop="postName">
					<Input v-model="addForm.postName" maxlength="100" placeholder="请输入岗位名称" clearable></Input>
				</FormItem>
				<FormItem label="排序">
					<Input type="number" v-model="addForm.sortIndex" placeholder="请输入排序(数值越大越靠前)"></Input>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="addForm.status==1" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>


	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					postName: '',
					sortIndex: 0,
					status: 0,
				},
				addRule: {
					postName: [{
						required: true,
						message: '请填写岗位名称',
						trigger: 'blur',
					}]
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '岗位名称',
						width: 300,
						key: 'postName',
						align: 'center'
					},
					{
						title: '状态',
						align: 'center',
						width: 200,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == 1) {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 300,
					}, {
						title: '操作',
						slot: 'action',
						width: 350,
						align: 'center'
					}

				]
			},

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.schoolJobPostPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},

			logoImgBack(response, file, fileList) {
				this.addForm.imgUrl = response.data.url
			},
			addSchoolJobShow() {
				this.addForm = {
					id: undefined,
					postName: '',
					sortIndex: 0,
					status: 0,
				}
				this.addJobShow = true
			},
			addOrEditData(row) {
				const that = this
				let addData = this.addForm
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.addOrEditSchoolJobPost(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateSchoolStatus(id, status) {
				const that = this
				api.statistics
					.updateSchoolJobPostStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(data) {
				this.addForm = data
				this.addJobShow = true
			},

		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>